import { FormikHelpers, FormikProps } from "formik";
import { fromPairs, isArray } from "lodash-es";

import { errorFieldType, IErrorEntry, IErrorField } from "@/core/api";
import { compose } from "@/core/url";
import { getApiError } from "@/formikComponents";

export const composeErrorMessage = (message: string, params: any) => {
  // TODO consider own compose using composeBuilder
  return compose(message, params);
};

export const getApiErrorType = (form: FormikProps<any>, name: string) => {
  const apiError = getApiError(form, name);
  return apiError && apiError.code;
};

export const applyApiErrors = (formActions: FormikHelpers<any>, payload: IErrorEntry) => {
  if (!isArray(payload && payload.errors)) {
    return;
  }

  const pairs = payload.errors
    .map(errorFieldType)
    .filter(e => e.field)
    .map((error: IErrorField) => [error.field, error]);

  const apiErrors = fromPairs(pairs);
  formActions.setStatus({ apiErrors });
};
